import React from 'react'
import InternalRequestListInboundOpsPage from 'domains/internal-request-ops/pages/internal-request-list-inbound-ops-page'
import InternalRequestDetailInboundOpsPage from 'domains/internal-request-ops/pages/internal-request-detail-inbound-ops-page'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import Phase3PriceTagPrintPage from 'domains/phase3-inbound-journey/pages/Phase3PriceTagPrintPage'
import Phase3InventoryBatchPage from 'domains/phase3-inbound-journey/pages/Phase3InventoryBatchPage'
import Phase3CreateIntakePage from 'domains/phase3-inbound-journey/pages/Phase3CreateIntakePage'
import { PHASE3_PRODUCT_SCOPES } from 'domains/phase3-inbound-journey/constants'

const inbound_team_routes = {
  collapse  : true,
  path      : '/inbound-team',
  name      : 'Inbound Team',
  icon      : 'ni ni-box-2 text-green',
  state_key : 'inbound_team_collapse',
  views     : [

    {
      collapse  : true,
      name      : 'Inbound Journey',
      miniName  : 'IJ',
      state_key : 'inbound_team_inbound_journey_collapse',
      views     : [
        {
          path      : '/inbound-team/inbound-journey/create-intake',
          name      : 'Create Consign',
          miniName  : 'CC',
          component : (props) => <Phase3CreateIntakePage { ...props } apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-team/inbound-journey/inventory-batches',
          name      : 'Inventory Batch',
          miniName  : 'IB',
          component : (props) => <Phase3InventoryBatchPage { ...props } apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-team/inbound-journey/ready-for-inbound',
          name      : 'Ready For Inbound',
          miniName  : 'RI',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.READY_FOR_INBOUND } title='Ready For Inbound' apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-team/inbound-journey/waiting-for-inbound',
          name      : 'Waiting For Inbound',
          miniName  : 'WI',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.WAITING_FOR_INBOUND } title='Waiting For Inbound' apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-team/inbound-journey/inbound-completed',
          name      : 'Completed',
          miniName  : 'CP',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.INBOUND_COMPLETED } title='Completed' apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/price-tag',
          name      : 'Price Tag',
          miniName  : 'PT',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.PRICE_TAG } title='Price Tag + Final Check' apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-team/inbound-journey/ready-to-live',
          invisible : true,
          name      : 'Ready To Live',
          miniName  : 'RL',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.READY_TO_LIVE } title='Ready To Live' apiNamespace='inbound' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/price-tag-print',
          name      : 'Price Tag Print',
          miniName  : 'PR',
          component : (props) => <Phase3PriceTagPrintPage { ...props } apiNamespace='inbound' />,
          layout    : '/app'
        }
      ]
    },
    {
      collapse  : true,
      name      : 'Internal Request',
      miniName  : 'IR',
      state_key : 'inbound_team_inventory_internal_request_collapse',
      views     : [
        {
          path      : '/inbounds/internal-requests/list-page',
          name      : 'Inbound Ops Queue',
          miniName  : 'Q',
          component : InternalRequestListInboundOpsPage,
          layout    : '/app'
        },
        {
          path      : '/inbounds/internal-requests/:id',
          name      : 'Inbound Ops Detail',
          component : InternalRequestDetailInboundOpsPage,
          layout    : '/app',
          invisible : true
        }
      ]
    }
  ]
}

export default inbound_team_routes
